import styled from 'styled-components';
import BaseCancelButton from 'shared/ui/CancelButton';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 15px;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
Title.displayName = 'Title';

export const ActionBar = styled.div`
  display: flex;
  .create-button {
    width: 89px;
  }
`;
ActionBar.ActionBar = 'ActionBar';

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 13px;
  width: 89px;
`;
CancelButton.displayName = 'CancelButton';
